import { render, staticRenderFns } from "./EntityResponsibles.vue?vue&type=template&id=3e0ac090"
import script from "./EntityResponsibles.vue?vue&type=script&lang=js"
export * from "./EntityResponsibles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports